import { TypographyP, TypographySmall } from '@talentmesh/ui/components/typography';
import { ArrowDown, ArrowUp } from 'lucide-react';
import { Aspect, aspectCompare } from '@/Models/Aspect';

interface CharacteristicAspectsProps {
    characteristicName: string;
    aspects: Aspect[];
}

function PersonalityCharacteristicAspects({ characteristicName, aspects }: CharacteristicAspectsProps) {
    return (
        <div className="flex flex-col gap-2">
            <TypographySmall className="text-foreground font-semibold">{characteristicName}</TypographySmall>
            {(aspects || []).sort(aspectCompare).map((aspect) => (
                <div key={aspect.descriptor} className="flex flex-row items-start justify-start gap-2">
                    {aspect.isHighDescriptor ? (
                        <ArrowUp className="text-percentile-top mt-0.5 size-4 shrink-0" />
                    ) : (
                        <ArrowDown className="text-percentile-very-low mt-0.5 size-4 shrink-0" />
                    )}
                    <TypographyP className="break-words">{aspect.descriptor}</TypographyP>
                </div>
            ))}
        </div>
    );
}

export default PersonalityCharacteristicAspects;
